import { GET_REVIVE_ITEMS } from 'constants/revive';

const initialState = {
  isFetching: false,
  data: {},
  error: null,
};

export const reviveReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case `${GET_REVIVE_ITEMS}_PENDING`: {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    }
    case `${GET_REVIVE_ITEMS}_FULFILLED`: {
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    }
    case `${GET_REVIVE_ITEMS}_REJECTED`: {
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};
